import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    nightlyWallet: 'Nightly Wallet',
  },
};
